import {DataContext} from "../Context/DataContext";
import {useState} from "react";
import Navbar from "../Navbar/Navbar";
import Invoice from '../Invoice';

function AdminInvoice(){
    const[searchUi,setSearchUi]=useState(false)
    return(

        <DataContext.Provider value={{searchUi,setSearchUi}}>
        <Navbar 
         navId={4}
        childrenPage={<Invoice/>}/>
        </DataContext.Provider>
    )
}

export default AdminInvoice;